// Loads the Google AdSense script once, only when a publisher ID is configured.
let loaded = false;

export const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "";

export function loadAdSense() {
  if (loaded || !ADSENSE_CLIENT) return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
  s.crossOrigin = "anonymous";
  document.head.appendChild(s);
}
